import {Component, OnInit, ViewChild} from '@angular/core';
import {StatCardComponent} from "../../shared/stat-card/stat-card.component";
import {CommonModule, getCurrencySymbol} from "@angular/common";
import {FilterBarComponent, FilterField} from "../../shared/filter-bar/filter-bar.component";
import {
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatRow,
    MatTableDataSource,
    MatTableModule
} from "@angular/material/table";
import {TripFilters, TripRecord, TripResponse} from "../../models/trip.model";
import {environment} from "../../../environments/environment";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {TripService} from "../../services/trip.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatPaginator, MatPaginatorModule, PageEvent} from "@angular/material/paginator";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {animate, state, style, transition, trigger} from '@angular/animations';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {ExcelExportService} from "../../services/excel-export.service";
import {getCurrencySymbolFromProjectID} from "../../utils/currency.utils";
import {saveAs} from "file-saver";
import {AuditLogsService} from "../../services/auditlogs.service";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-rider-trips',
    standalone: true,
    templateUrl: './rider-trips.component.html',
    styleUrl: './rider-trips.component.scss',
    imports: [CommonModule, StatCardComponent, FilterBarComponent, MatTableModule, MatButtonModule, MatIconModule,
        MatProgressBarModule, MatPaginatorModule, MatSortModule, MatColumnDef, MatHeaderCell, MatCell, MatHeaderRow, MatRow,
        ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatNativeDateModule],
    providers: [
    ],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0', visibility: 'hidden'})),
            state('expanded', style({height: '*', visibility: 'visible'})),
            transition('expanded <=> collapsed', animate('150ms ease-in-out')),
        ]), trigger('chevronRotate', [
            state('collapsed', style({transform: 'rotate(0deg)'})),
            state('expanded', style({transform: 'rotate(180deg)'})),
            transition('expanded <=> collapsed', animate('180ms ease')),
        ]),
    ]
})
export class RiderTripsComponent implements OnInit {

    selectedFileName: string = "";
    loading: boolean = false;
    dataSource = new MatTableDataSource<TripRecord>([]);
    displayedColumns: string[] = [
        'trip_number',
        'rider_name',
        'start_time',
        'end_time',
        'actual_distance',
        'payment_amount',
        'deliveries',
        'created_at',
        'actions'
    ];

    fields: FilterField[] = [
        {key: 'rider_name', type: "text", label: "Rider's Name"},
        {key: 'start_date', type: "date", label: "Start Date"},
        {key: 'end_date', type: "date", label: "End Date"}
    ];

    form: FormGroup;


    total_trips = 0;
    total_deliveries = 0;
    due = 0;
    currency:string;
    total_amount:string;
    filters: TripFilters = {
        page: 1,
        page_size: environment.deliveryFormPageSize,
        rider_name: null,
        start_date: null,
        end_date: null
    };
    success = 16;
    failed = 8;

    totalItems = 0;
    currentPage = 1;
    pageSize = environment.deliveryFormPageSize;

    _rows: TripRecord[] = [];

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    expandedElement: any | null = null;
    // predicate used by *matRowDef "when"
    isExpanded = (_: number, row: any) => row === this.expandedElement;


    constructor(
        private tripsService: TripService,
        private snack: MatSnackBar,
        private fb: FormBuilder,
        private excelService: ExcelExportService,
        private auditLogsService: AuditLogsService,
        private toaster: ToastrService,
    ) {

        this.form = this.fb.group({
            rider_code: [''],
            start: [null],
            end: [null],
        });
    }

    ngOnInit() {
        this.currency = getCurrencySymbolFromProjectID(localStorage.getItem("orgId"))
        this.auditLogsService.postLog("View Rider Trips").subscribe();
        this.refresh(null);
    }

    private setFilters(payload?: Record<string, any> | null): void {
        if (!payload) {
            return;
        }
        this.filters = {
            page: 1,
            page_size: this.pageSize ?? environment.deliveryFormPageSize,
        };

        if (!payload) {
            return;
        }

        if (payload.rider_name != null && payload.rider_name !== '') {
            this.filters.rider_name = payload.rider_name;
        }

        if (payload.start_date != null && payload.start_date !== '') {
            this.filters.start_date = payload.start_date;
        }

        if (payload.end_date != null && payload.end_date !== '') {
            this.filters.end_date = payload.end_date;
        }
    }




    onPage(e: PageEvent) {
        this.pageSize = e.pageSize;
        this.filters.page = e.pageIndex + 1;   // API is 1-based, paginator is 0-based
        this.filters.page_size = this.pageSize;
        this.refresh(null);
    }

    onApply(payload: Record<string, any>) {
        this.auditLogsService.postLog("Filter Rider Trips", {
            metadata: payload || {}
        }).subscribe();
        this.refresh(payload)
    }

    onReset() {
        console.log('reset');
    }

    refresh(payload: Record<string, any>): void {

        this.loading = true;
        this.setFilters(payload);

        this.tripsService.fetchTrips(this.filters).subscribe({

            next: (response: TripResponse) => {

                // Coerce numbers if your API returns strings for distances
                const items = (response.items || []).map(it => ({
                    ...it,
                    actual_distance: it.actual_distance != null ? +it.actual_distance : null,
                    estimated_distance: it.estimated_distance != null ? +it.estimated_distance : null,
                    delivery_count: Array.isArray(it.deliveries) ? it.deliveries.length : 0
                }));

                this.dataSource = new MatTableDataSource(items);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.total_trips = response.total_trips;
                this.total_deliveries = response.total_deliveries;
                this.total_amount = this.currency + " "+response.total_payment_amount

            }, error: (error: any) => {

            }, complete: () => this.loading = false

        });
    }

    onFileSelected(evt: Event) {
        const input = evt.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) return;

        const file = input.files[0];
        this.selectedFileName = file.name;

        this.loading = true;
        this.tripsService.uploadCsv(file).subscribe({
            next: (res) => {
                const msg = `Uploaded: ${res.inserted} • Skipped: ${res.skipped} • Trip links: ${res.trip_deliveries_created ?? 0}`;
                this.snack.open(msg, 'OK', {duration: 4500});
                this.auditLogsService.postLog("Upload Trips CSV", {
                    metadata: {
                        fileName: file.name,
                        inserted: res.inserted,
                        skipped: res.skipped,
                        trip_deliveries_created: res.trip_deliveries_created ?? 0
                    }
                }).subscribe();
                // refresh table to show new rows
                this.refresh(null);
            },
            error: (err) => {
                console.error(err);
                const msg = err?.error?.detail || 'Upload failed';
                this.snack.open(msg, 'Dismiss', {duration: 4500});
            },
            complete: () => {
                this.loading = false;
                // clear file input so the same file can be reselected later if needed
                input.value = '';
                this.selectedFileName = '';
            }
        });
    }

    viewTrip(row: TripRecord) {
        // open a dialog or route to trip details—stub
        this.expandedElement = this.expandedElement === row ? null : row;
    }


    downloadReport() {
        this.loading = true;

        let apiUrl = `${environment.apiUrl}/trip/export`

        this.excelService.exportToExcel(this.filters, apiUrl).subscribe({
            next: (blob) => {
                saveAs(blob, "Trips Report");
                this.loading = false;
            },
            error: (error) => {
                this.toaster.error("Unable to generate trips report");
                this.loading = false;
            }, complete: () => this.loading = false
        });
        this.auditLogsService.postLog("Download Trips Report").subscribe({
            next: (response) => {

            }, error: (error) => {

            }
        });

    }


}
